import {
  CONTENT_FILTER_MAX_TERMS,
  CONTENT_FILTER_TERM_MAX_RAW,
  CONTENT_FILTER_TERM_MIN_NORMALIZED,
  CONTENT_FILTER_TOTAL_MAX,
} from "./types";

export function isWorkspaceAdminRole(role: string | undefined | null): boolean {
  return role === "owner" || role === "admin";
}

/** Same NFKC / control / whitespace stripping as api/src/services/ugc.ts `normalizeFilterText`. */
export function normalizeFilterText(input: string): string {
  let out = input.normalize("NFKC").toLowerCase();
  let stripped = "";
  for (const ch of out) {
    const code = ch.codePointAt(0) ?? 0;
    if (code <= 0x1f || (code >= 0x7f && code <= 0x9f)) continue;
    if (code === 0x200b || code === 0x200c || code === 0x200d || code === 0xfeff) continue;
    if (/\s/u.test(ch) || ch === "\u3000") continue;
    stripped += ch;
  }
  return stripped;
}

export function parseContentFilterTerms(raw: string): string[] {
  return raw
    .split(/\r?\n/)
    .map((term) => term.trim())
    .filter(Boolean);
}

export function looksLikeRegexTerm(term: string): boolean {
  const trimmed = term.trim();
  if (trimmed.length >= 2 && trimmed.startsWith("/") && trimmed.endsWith("/")) return true;
  return /[\\^$|()[\]{}]|\.\*|\.\+|\[\^/.test(trimmed);
}

export function validateContentFilterTerms(terms: readonly string[]): string[] {
  const issues: string[] = [];
  if (terms.length > CONTENT_FILTER_MAX_TERMS) {
    issues.push(`語句は ${CONTENT_FILTER_MAX_TERMS} 件までです（現在 ${terms.length} 件）。`);
  }
  let total = 0;
  for (const term of terms) {
    total += term.length;
    if (term.length > CONTENT_FILTER_TERM_MAX_RAW) {
      issues.push(`「${term.slice(0, 24)}」は ${CONTENT_FILTER_TERM_MAX_RAW} 文字までです。`);
      continue;
    }
    if (looksLikeRegexTerm(term)) {
      issues.push(`「${term.slice(0, 24)}」は特殊な記号の並びのため登録できません。通常の語句を入力してください。`);
      continue;
    }
    if (normalizeFilterText(term).length < CONTENT_FILTER_TERM_MIN_NORMALIZED) {
      issues.push(
        `「${term.slice(0, 24)}」は全角半角・空白をそろえると短すぎます。${CONTENT_FILTER_TERM_MIN_NORMALIZED} 文字以上の具体的な語句にしてください。`,
      );
    }
  }
  if (total > CONTENT_FILTER_TOTAL_MAX) {
    issues.push(`語句の合計は ${CONTENT_FILTER_TOTAL_MAX} 文字までです（現在 ${total} 文字）。`);
  }
  return issues;
}
